<template>
  <li class="about-menu-nav-item">
    <component
      :is="props.component"
      class="about-menu-nav-item__link"
      :class="{ 'about-menu-nav-item__link--active': props.isActive }"
      v-bind="props.componentProps"
      @click="emit('select')"
    >
      {{ props.text }}
    </component>
  </li>
</template>

<script setup lang="ts">
import type { AboutMenuNavItemProps } from '../model/types';

const props = defineProps<AboutMenuNavItemProps>();

const emit = defineEmits<{
  select: [];
}>();
</script>

<style scoped lang="scss">
.about-menu-nav-item {
  margin: 0;
}

.about-menu-nav-item__link {
  display: inline-flex;
  width: 100%;
  padding-top: var(--alias-space-4);
  padding-bottom: var(--alias-space-4);
  color: var(--alias-color-text-default);
  text-decoration: none;

  @include typography.base-400-400-regular;
}

.about-menu-nav-item__link--active {
  padding-right: var(--alias-space-8);
  padding-left: var(--alias-space-8);
  background-color: var(--alias-color-background-subtle);
  border-radius: var(--alias-radius-8);
  transform: translateX(calc(var(--alias-space-8) * -1));
}
</style>
